import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { FormProvider } from "react-hook-form";
import { useTranslate } from "src/locales";
import { usePageOneForm } from "./hooks/usePageOneForm";
import { FormCreationInfo } from "./components/FormCreationInfo";
import { IdentifyingPersons } from "./components/IdentifyingPersons";
import { SafetyMeasures } from "./components/SafetyMeasures";
import { WristbandInfo } from "./components/WristbandInfo";
import { RoomSystems } from "./components/RoomSystems";
import { PatientAssessmentDetails } from "./components/PatientAssessmentDetails";

function PageOne() {
  const { t } = useTranslate();
  const { formMethods, onSubmit } = usePageOneForm();

  return (
    <FormProvider {...formMethods}>
      <Box sx={{ paddingTop: "20px" }}>
        <form onSubmit={onSubmit}>
          <Grid container spacing={2} sx={{ padding: "0px" }}>
            <Grid md={12} xs={12} container direction={"row"} spacing={3} sx={{ padding: "0px", margin: "0px" }}>
              <FormCreationInfo />
              <IdentifyingPersons />
            </Grid>

            <Grid md={12} xs={12} container direction={"row"} spacing={2} sx={{ padding: "0px", paddingTop: "20px", margin: "0px" }}>
              <SafetyMeasures />
              <WristbandInfo />
              <RoomSystems />
            </Grid>

            <PatientAssessmentDetails />

            <Grid md={12} xs={12} sx={{ display: "flex", justifyContent: "flex-end", paddingTop: "20px" }}>
              <Button type="submit" variant="contained" color="primary">
                {t("buttons.save")}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </FormProvider>
  );
}

export default PageOne;
